import * as types from '@/store/newProject/actionTypes';
import {
  SET_NEW_PROJECT, SET_NEW_PROJECT_NAVIGATION,
} from '@/store/newProject/mutationTypes';
import { createRunMutationAction } from '@/store/utils';

export default {
  [types.SET_NEW_PROJECT]: createRunMutationAction(SET_NEW_PROJECT),
  [types.SET_NEW_PROJECT_NAVIGATION]: createRunMutationAction(SET_NEW_PROJECT_NAVIGATION),
};
